import { createFileRoute, Link } from "@tanstack/react-router";
import { Shield, Clock, MapPin, Heart, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About Bacha Way Travel | Moroccan Private Transfer Company" },
      { name: "description", content: "Bacha Way Travel is a Moroccan-owned private transfer company. Local expertise, professional drivers, and a commitment to comfort across Morocco." },
      { property: "og:title", content: "About Bacha Way Travel" },
      { property: "og:description", content: "Moroccan-owned private transfer company. Local expertise, professional drivers, and a commitment to comfort." },
      { property: "og:url", content: "https://bachawaytravel.com/about" },
    ],
    links: [{ rel: "canonical", href: "https://bachawaytravel.com/about" }],
  }),
  component: AboutPage,
});

function AboutPage() {
  const { t } = useTranslation();
  const values = [
    { icon: Shield, t: t("about.v1t"), d: t("about.v1d") },
    { icon: Clock, t: t("about.v2t"), d: t("about.v2d") },
    { icon: MapPin, t: t("about.v3t"), d: t("about.v3d") },
    { icon: Heart, t: t("about.v4t"), d: t("about.v4d") },
  ];
  return (
    <div className="mx-auto max-w-4xl px-6 py-16 md:py-24">
      <div className="text-xs uppercase tracking-[0.2em] text-primary">{t("about.eyebrow")}</div>
      <h1 className="mt-3 font-display text-5xl md:text-6xl">About Bacha Way Travel</h1>

      <div className="mt-10 space-y-6 text-muted-foreground leading-relaxed text-lg">
        <p>{t("about.p1")}</p>
        <p>{t("about.p2")}</p>
        <p>{t("about.p3")}</p>
      </div>

      <div className="mt-14 grid gap-5 md:grid-cols-2">
        {values.map((v) => (
          <div key={v.t} className="flex gap-4 rounded-xl border border-border bg-card p-5">
            <v.icon className="h-6 w-6 text-primary mt-0.5 shrink-0" />
            <div>
              <div className="font-medium text-foreground">{v.t}</div>
              <div className="text-sm text-muted-foreground mt-1">{v.d}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-16">
        <Link to="/booking" className="inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3 text-sm font-medium text-primary-foreground hover:opacity-90">
          {t("common.book")} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
